import React, { useRef, useEffect } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css'; // Import the Quill styles

const QuillEditor = ({ value, onChange }) => {
    const quillRef = useRef(null);
    const quillInstance = useRef(null); // Store the Quill instance

    useEffect(() => {
        if (!quillInstance.current) {
            // Initialize Quill only once
            const quill = new Quill(quillRef.current, {
                theme: 'snow',
                modules: {
                    toolbar: [
                        [{ header: '1' }, { header: '2' }, { font: [] }],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        ['bold', 'italic', 'underline'],
                        [{ align: [] }],
                        ['link'],
                    ],
                },
            });
            quillInstance.current = quill;

            // Update the editor content with the value prop
            quill.root.innerHTML = value;

            // Listen for text changes and pass the updated content to the parent
            quill.on('text-change', () => {
                const content = quill.root.innerHTML;
                onChange(content); // Pass updated content to the parent
            });
        }
    }, [value, onChange]); // Only reinitialize if the value or onChange function changes

    return <div ref={quillRef} />;
};

export default QuillEditor;
